// Tab and wizard step indices per module.
// Split from constants.js — edit here, not the barrel.

import { STATUS } from './core'
import { CATEGORY, PRODUCT } from './internal'
import { REDEEM_GROUP } from './types'

export const tabs = {
RESTAURANT_TAB: {
        INFO: 0,
        QUEUE: 1,
        RESERVATION: 2,
        PICKUP: 3,
        MERCHANT: 4,
        MEDIA: 5,
        PRODUCT: 6,
        REPORT: 7,
        SURVEY: 8
    },
PICKUP_TAB: {
        INFO: 0,
    },
RESTAURANT_SUB_TAB: {
        INFO: 0,
        STATUS: 1,
        ADMIN_DEVICE: 2,
        CAMPAIGN_DESCRIPTION: 3,
        TNC: 4,
        SELECT_TAG: 5,
        PAYMENT: 6,
        SHOP_DASHBOARD: 7,
    },
RESTAURANT_MEDIA_TAB: {
        INFO: 0,
    },
RESTAURANT_BLACKOUT_TAB: {
        INFO: 0,
    },
RESTAURANT_SLIDESHOW_TAB: {
        INFO: 0,
    },
RESTAURANT_QUEUE_SUB_TAB: {
        QUEUE_STATUS: 0,
        QUEUE_CHANNEL_FUNCTION: 1,
        QUEUE_CONFIG: 2,
        PRINT_CONFIG: 3,
        QUEUE_TEMPLATE: 4,
        QUEUE_TEMPLATE_MAP: 5,
        QUEUE_REJECT_REASON: 6,
        DASHBOARD: 7,
    },
RESTAURANT_RESERVATION_SUB_TAB: {
        RESERVATION_CONFIG: 0,
        RESERVATON_REJECT_REASON: 1,
        // RESERVATION_TEMPLATE: 1,
        // RESERVATION_TEMPLATE_MAP: 2,
        // CHARGE_DATE: 3,
    },
RESTAURANT_PICKUP_SUB_TAB: {
        PICKUP_CONFIG: 0,
        // RESERVATION_TEMPLATE: 1,
        // RESERVATION_TEMPLATE_MAP: 2,
        // CHARGE_DATE: 3,
    },
RESTAURANT_MERCHANT_SUB_TAB: {
        MERCHANT_CONFIG: 0,
        MERCHANT_DEVICE: 1,
        COUNTER: 2,
        STAFF: 3,
        QUEUE_PROFILE: 4,
        QUEUE_TRANSFER_PROFILE: 5,
        COUNTER_PROFILE: 6,
    },
RESTAURANT_MEDIA_SUB_TAB: {
        MEDIA: 0,
        BANNER_LIST: 1,
        SLIDESHOW: 2,
    },
RESTAURANT_PRODUCT_SUB_TAB: {
        BLACKOUT: 0,
    },
RESTAURANT_SELECT_TAG_SUB_TAB: {
        SELECT_TAG_CONFIG: 0,
    },
URL_MAP_TAB: {
        INFO: 0,
    },
ADMIN_DEVICE_EDIT_TAB: {
        INFO: 0,
    },
CAMPAIGN_DESCRIPTION_EDIT_TAB: {
        INFO: 0,
    },
TNC_EDIT_TAB: {
        INFO: 0,
    },
QUEUE_REJECT_REASON_EDIT_TAB: {
        INFO: 0,
    },
RESERVATION_REJECT_REASON_EDIT_TAB: {
        INFO: 0,
    },
EMAIL_TEMPLATE_EDIT_TAB: {
        INFO: 0,
    },
PRINT_TEMPLATE_EDIT_TAB: {
        INFO: 0,
    },
PRODUCT_CAT_TAB: {
        INFO: 0,
        PRODUCT_MAP_LIST: 1,
    },
PRODUCT_MAP_TAB: {
        INFO: 0,
    },
REDEEM_GROUP_TAB: {
        NFO: 0,
    },
PRODUCT_TAB: {
        INFO: 0,
        IMAGE_LIST: 1,
        ATTRIBUTE_LIST: 3,
        BLACKOUT_PERIOD_LIST: 2,
    },
PRODUCT_DRAFT_STEP: {
        // USER_GROUP: 0,
        CATEGORY: 0,
        REDEEM_GROUP: 1,
        PRODUCT: 2,
        PRODUCT_LOT: 3,
    },
MERCHANT_DRAFT_STEP: {
        RESTAURANT: 0,
        IMAGE: 1,
        ACCOUNT: 2,
        SERVICE_AND_PLAN: 3,
        BRAND: 4,
    },
FOLDER_TAB: {
        INFO: 0,
        FOLDER_MAP_LIST: 1,
        BANNER_LIST: 2,
    },
FOLDER_MAP_TAB: {
        INFO: 0,
    },
SLIDESHOW_BULK_CREATE_STEP: {
        SLIDESHOW: 0,
        RESTAURANT_MAP_LIST: 1,
    },
BANNER_TAB: {
        INFO: 0,
    },
BANNER_SUB_TAB: {
        BANNER_EN_IMAGE: 0,
        BANNER_TC_IMAGE: 1,
        BANNER_SC_IMAGE: 2,
    },
TICKET_BANNER_TAB: {
        TICKET_BANNER_MAP_LIST: 1,
    },
TICKET_BANNER_MAP_TAB: {
        INFO: 0,
    },
PUSH_TAB: {
        INFO: 0,
    },
AREA_EDIT_TAB: {
        INFO: 0,
        DISTRICT_LIST: 1,
    },
DISTRICT_TAB: {
        INFO: 0,
        RESTAURANT_MAP_LIST: 1,
        LANDMARK_MAP_LIST: 2,
    },
LANDMARK_TAB: {
        INFO: 0,
        DISTRICT_LIST: 1,
        RESTAURANT_LIST: 2,
    },
LANDMARK_DISTRICT_MAP_TAB: {
        INFO: 0,
    },
TAG_EDIT_TAB: {
        INFO: 0,
        RESTAURANT_MAP_LIST: 1,
    },
RESTAURANT_MAP_LIST_TAB: {
        INFO: 0,
    },
QUEUE_TEMPLATE_TAB: {
        INFO: 0,
    },
QUEUE_PROFILE_TAB: {
        INFO: 0,
    },
QUEUE_TRANSFER_PROFILE_TAB: {
        INFO: 0,
    },
QUEUE_TEMPLATE_TIME_SECTION_TAB: {
        INFO: 0,
        TABLE_TYPE: 1,
    },
QUEUE_TEMPLATE_MAP_TAB: {
        INFO: 0,
    },
RESERVATION_TEMPLATE_TAB: {
        INFO: 0,
    },
RESERVATION_TEMPLATE_TIME_SECTION_TAB: {
        INFO: 0,
        TABLE_TYPE: 1,
    },
RESERVATION_TEMPLATE_MAP_TAB: {
        INFO: 0,
    },
CHARGE_DATE_TAB: {
        INFO: 0,
    },
MERCHANT_DEVICE_EDIT_TAB: {
        INFO: 0,
        DEVICE_LOG: 1,
    },
MERCHANT_USER_EDIT_TAB: {
        INFO: 0,
    },
MERCHANT_USER_GROUP_EDIT_TAB: {
        INFO: 0,
        RESTAURANT_MAP: 1,
    },
MERCHANT_SALES_USER_EDIT_TAB: {
        INFO: 0,
    },
CONTACT_US_EDIT_TAB: {
        INFO: 0,
    },
SELECT_TAG_TAB: {
        INFO: 0,
    },
SELECT_TAG_EDIT_TAB: {
        INFO: 0,
    },
RESTAURANT_PAYMENT_EDIT_TAB: {
        INFO: 0,
    },
PAYMENT_EDIT_TAB: {
        INFO: 0,
    },
RESTAURANT_APPROVE_EDIT_TAB: {
        INFO: 0,
        PAYMENT_LIST: 1,
        MERCHANT_INFO: 2,
    },
BRAND_APPROVE_EDIT_TAB: {
        INFO: 0,
    },
MERCHANT_INFO_EDIT_TAB: {
        INFO: 0,
    },
}
